function PiaSigning() {
  const renderer = require('Renderer');
  let signButton
  let pia

  this.init = function () {
    pia = JSON.parse(sessionStorage.getItem('pia'));
    new UpdateContactInfo(session.customer, renderApplication).init()
    return {}
  }

  function initAssets() {
    return session.pension.secondPillar.assets.map(function (asset) {
      return { //TODO reuse java class
        fundName: asset.fund.name,
        soldPercentage: pia.percentages[asset.fund.isin],
        soldAmount: pia.amounts[asset.fund.isin] * pia.percentages[asset.fund.isin] / 100
      }
    })
  }

  function prepare() {
    signButton.attr('disabled', true)
    return $.post('/application/second-pillar/pia/prepare', {'pia': JSON.stringify(pia)})
      .then(function(response) {
        return response;
      })
  }

  function sendApplication(signedDocument) {
    let params = Object.assign({}, signedDocument, {'piaId': pia.id})
    let post = $.post('/application/second-pillar/pia/send-application', params)
    return post.fail(function (xhr) {
      if (!!xhr.responseJSON && !!xhr.responseJSON.error) {
        $('#technical-error').text(xhr.responseJSON.error)
      }
      else {
        $('#technical-error').text(xhr.responseText)
      }

      $('#technical-error').removeClass('d-none')
      signButton.removeAttr('disabled')
    })
  }

  function onSigned(signedDocument) {
    sendApplication(signedDocument).then(function(sendApplicationResponse) {
      sessionStorage.removeItem('pia')
      location.href = '#piasuccess' +
        '?signedDocumentId=' + signedDocument['signedDocumentId'] +
        '&applicationId=' + signedDocument['applicationId'] +
        '&executionDate=' + sendApplicationResponse['executionDate']
    })
  }

  function sign() {
    $('#technical-error').addClass('d-none')
    new Signer(session.authType, prepare, onSigned).sign()
    return false;
  }

  this.done = function() {
    signButton = $('#sign-pia')
    signButton.on('click', sign)
    signButton.prop('disabled', !$('#agreePIATerms').is(':checked'))

    $(document).on('change', '#agreePIATerms', function(e) {
      signButton.prop('disabled', !$(e.target).is(':checked'))
    })

    $('[readonly]').on('click', function(e) {e.preventDefault()})

    $(document).on('change', '[name="authorize"]', onCheckboxChanged)

    renderApplication()
  }

  function onCheckboxChanged(e) {
    pia.authorize = e.target.checked
    renderApplication()
  }

  function renderApplication() {
    $('#pia-application-content').html(renderer.template('pia-application')({
      customer: session.customer,
      piaAccount: pia.account,
      piaAuthorised: pia.authorize,
      assets: initAssets(),
      isSuspended: session.pension.secondPillar.isSuspended && session.pension.secondPillar.isSuspendCancelable,
      isExited: session.pension.secondPillar.isExited && session.pension.secondPillar.isExitCancelable
    }))
  }
}
